<style lang="scss" scoped>
@import "./home.less";
</style>
<template>
  <div class="home">
    <div id="home" class="home__main scroll-touch" @scroll="setScroll">
      <div v-for="(data, index2) in homePageData" :key="index2">
        <!-- 轮播图模块 -->
        <div
            v-if="data.moduleType == 0 && data.homepageData.length > 0"
            id="swiper_home"
            :mg-stat-mod="data.moduleId"
            class="swiper-container home__banner"
        >
          <div class="swiper-wrapper">
            <div
                v-for="(item, index) in data.homepageData"
                :key="index"
                :mg-stat-lob="`smod=${data.moduleId}&mdid=${item.moduleDataId}&stype=1`"
                class="swiper-slide"
                mg-stat-show="flag=200"
            >
              <img
                  :data-link="item.url"
                  :mg-stat-custom="'label=img&cont='+item.moduleDataId+'&direct=cntp&addr=' + encodeURIComponent(item.url)"
                  :mg-stat-lob="'goods_id='+getRequest(item.url)"
                  :src="item.img"
                  alt=""
                  mg-stat-click
              />
            </div>
          </div>
          <div v-if="data.bottomImg" class="home__banner-background">
            <img :src="data.bottomImg" alt=""/>
          </div>
          <div class="swiper-pagination"></div>
        </div>

        <!-- icon模块 -->
        <div
            v-if="data.moduleType == 1 && data.homepageData.length > 0"
            :class="['home__activity', data.type == 0 ? '' : 'pureGraph']"
            :mg-stat-lob="`smod=${data.moduleId}&stype=1`"
            :style="data.bottomImg ? { background: 'url(' + data.bottomImg + ')', backgroundSize: 'contain'}: ''"
            mg-stat-show="flag=200"
        >
          <div
              v-for="(item, index) in data.homepageData"
              :key="index"
              class="home__activity-item"
          >
            <div v-if="data.type == 0" class="home__activity-item">
              <div class="home__activity-img">
                <img
                    :mg-stat-custom="'label=special&cont='+getRequest(item.url)+'&direct=cntp&addr='+encodeURIComponent(item.url)"
                    :src="item.img"
                    mg-stat-click
                    @click="gotoIframe(item.url)"/>
              </div>
              <div class="home__activity-title">
                <p class="add_dot">{{ item.iconTitle }}</p>
              </div>
            </div>
            <div v-else>
              <img
                  :mg-stat-custom="'label=special&cont='+getRequest(item.url)+'&direct=cntp&addr='+encodeURIComponent(item.url)"
                  :src="item.img"
                  mg-stat-click
                  @click="gotoIframe(item.url)"/>
            </div>
          </div>
        </div>

        <!-- 大单图模块 -->
        <div
            v-if="data.moduleType == 2 && data.homepageData.length > 0"
            :mg-stat-lob="`smod=${data.moduleId}&stype=1`"
            :mg-stat-mod="data.moduleId"
            :style="{background: 'url(' + data.bottomImg + ')',backgroundSize: 'contain'}"
            class="home__bigSingleMap"
            mg-stat-show="flag=200"
        >
          <img
              :mg-stat-custom="'label=goods&cont='+getRequest(data.homepageData[0].url)+'&direct=cntp&addr=' +encodeURIComponent(data.homepageData[0].url)"
              :mg-stat-lob="`goodsdc=${goodsdc}`"
              :src="data.homepageData[0].img"
              mg-stat-click
              @click="gotoIframe(data.homepageData[0].url)"/>
        </div>

        <!-- 小单图模块 -->
        <div
            v-if="data.moduleType == 3 && data.homepageData.length > 0"
            :mg-stat-lob="`smod=${data.moduleId}&stype=1`"
            :mg-stat-mod="data.moduleId"
            :style="{background: 'url(' + data.bottomImg + ')',backgroundSize: 'contain'}"
            class="home__smallSingleMap"
            mg-stat-show="flag=200"
        >
          <img
              :mg-stat-custom="'label=goods&cont='+getRequest(data.homepageData[0].url)+'&direct=cntp&addr=' +encodeURIComponent(data.homepageData[0].url)"
              :mg-stat-lob="`goodsdc=${goodsdc}`"
              :src="data.homepageData[0].img"
              mg-stat-click
              @click="gotoIframe(data.homepageData[0].url)"
          />
        </div>
        <!-- 自定义二图 -->
        <div
            v-if="data.moduleType == 4 && data.homepageData.length > 0"
            :mg-stat-lob="`smod=${data.moduleId}&stype=1`"
            :mg-stat-mod="data.moduleId"
            :style="{background: 'url(' + data.bottomImg + ')',backgroundSize: 'contain'}"
            class="home__customTwoMap"
            mg-stat-show="flag=200"
        >
          <module-title :data="data"></module-title>
          <div class="home__customTwoMap-main">
            <div
                v-for="(item, index) in data.homepageData"
                :key="index"
                :mg-stat-custom="'label=goods&cont='+getRequest(item.url)+'&direct=cntp&addr=' +encodeURIComponent(item.url)"
                :mg-stat-lob="`goodsdc=${goodsdc}`"
                class="home__customTwoMap-item"
                mg-stat-click
                @click="gotoIframe(item.url)"
            >
              <!-- 图文 -->
              <div v-if="data.type == 0">
                <div class="home__customTwoMap-left">
                  <div class="customTitle">
                    <p class="add_dot">{{ item.mainTitle }}</p>
                    <p class="add_dot">{{ item.viceTitle }}</p>
                  </div>
                </div>
                <div class="home__customTwoMap-right">
                  <img v-lazy="item.img"/>
                </div>
              </div>
              <!-- 纯图 -->
              <div
                  v-else
                  class="home__customTwoMap-block"
                  @click="gotoIframe(item.url)"
              >
                <img v-lazy="item.img"/>
              </div>
            </div>
          </div>
        </div>
        <!-- 自定义三图 -->
        <div
            v-if="data.moduleType == 5 && data.homepageData.length > 0"
            :mg-stat-lob="`smod=${data.moduleId}&stype=2`"
            :mg-stat-mod="data.moduleId"
            :style="{background: 'url(' + data.bottomImg + ')',backgroundSize: 'contain'}"
            class="home__customThreeMap"
            mg-stat-show="flag=200"
        >
          <module-title :data="data"></module-title>
          <div class="home__customThreeMap_main">
            <div class="home__customThreeMap_left">
              <div
                  v-for="(item, index) in data.homepageData"
                  :key="index"
                  :mg-stat-custom="'label=goods&cont='+getRequest(item.url)+'&direct=cntp&addr=' +encodeURIComponent(item.url)"
                  :mg-stat-lob="`goodsdc=${goodsdc}`"
                  mg-stat-click
                  @click="gotoIframe(item.url)"
              >
                <!-- 左边两张图 -->
                <div
                    v-if="data.type == 0 && index < 2"
                    class="home__customThreeMap_left-item"
                >
                  <div class="home__customThreeMap_left-img">
                    <img v-lazy="item.img"/>
                  </div>
                  <div class="home__customThreeMap_left-title">
                    <div class="customTitle">
                      <p class="add_dot">{{ item.mainTitle }}</p>
                      <p class="add_dot">{{ item.viceTitle }}</p>
                    </div>
                  </div>
                </div>
                <div
                    v-else-if="data.type != 0 && index < 2"
                    class="home__customThreeMap_left-block"
                    @click="gotoIframe(item.url)"
                >
                  <img v-lazy="item.img"/>
                </div>
              </div>
            </div>
            <div class="home__customThreeMap_right">
              <div
                  v-for="(item, index) in data.homepageData"
                  :key="index"
                  :mg-stat-custom="'label=goods&cont='+getRequest(item.url)+'&direct=cntp&addr=' +encodeURIComponent(item.url)"
                  :mg-stat-lob="`goodsdc=${goodsdc}`"
                  mg-stat-click
                  @click="gotoIframe(item.url)">
                <div
                    v-if="data.type == 0 && index == 2"
                    class="home__customThreeMap_right-item"
                >
                  <div class="home__customThreeMap_right-title">
                    <div class="customTitle">
                      <p class="add_dot">{{ item.mainTitle }}</p>
                      <p class="add_dot">{{ item.viceTitle }}</p>
                    </div>
                  </div>
                  <div class="home__customThreeMap_right-img">
                    <img v-lazy="item.img"/>
                  </div>
                </div>
                <div
                    v-else-if="data.type != 0 && index == 2"
                    class="home__customThreeMap_right-block"
                    @click="gotoIframe(item.url)"
                >
                  <img v-lazy="item.img"/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 自定义三图 反向 -->
        <div
            v-if="data.moduleType == 6 && data.homepageData.length > 0"
            :mg-stat-lob="`smod=${data.moduleId}&stype=2`"
            :mg-stat-mod="data.moduleId"
            :style="{
            background: 'url(' + data.bottomImg + ')',
            backgroundSize: 'contain '
          }"
            class="home__customThreeMap"
            mg-stat-show="flag=200"
        >
          <module-title :data="data"></module-title>
          <div class="home__customThreeMap_main">
            <div class="home__customThreeMap_right">
              <div
                  v-for="(item, index) in data.homepageData"
                  :key="index"
                  :mg-stat-custom="'label=goods&cont='+getRequest(item.url)+'&direct=cntp&addr=' +encodeURIComponent(item.url)"
                  :mg-stat-lob="`goodsdc=${goodsdc}`"
                  mg-stat-click
                  @click="gotoIframe(item.url)"
              >
                <div
                    v-if="data.type == 0 && index == 0"
                    class="home__customThreeMap_right-item"
                >
                  <div class="home__customThreeMap_right-title">
                    <div class="customTitle">
                      <p class="add_dot">{{ item.mainTitle }}</p>
                      <p class="add_dot">{{ item.viceTitle }}</p>
                    </div>
                  </div>
                  <div class="home__customThreeMap_right-img">
                    <img v-lazy="item.img"/>
                  </div>
                </div>
                <div
                    v-else-if="data.type != 0 && index == 0"
                    class="home__customThreeMap_right-block"
                    @click="gotoIframe(item.url)"
                >
                  <img v-lazy="item.img"/>
                </div>
              </div>
            </div>

            <div class="home__customThreeMap_left">
              <div
                  v-for="(item, index) in data.homepageData"
                  :key="index"
                  :mg-stat-custom="'label=goods&cont='+getRequest(item.url)+'&direct=cntp&addr=' +encodeURIComponent(item.url)"
                  :mg-stat-lob="`goodsdc=${goodsdc}`"
                  mg-stat-click
                  @click="gotoIframe(item.url)">
                <div
                    v-if="data.type == 0 && index > 0"
                    class="home__customThreeMap_left-item"
                    style="display : flex;justify-content: flex-end;text-align:right"
                >
                  <div class="home__customThreeMap_left-title">
                    <div class="customTitle">
                      <p class="add_dot">{{ item.mainTitle }}</p>
                      <p class="add_dot">{{ item.viceTitle }}</p>
                    </div>
                  </div>
                  <div class="home__customThreeMap_left-img">
                    <img v-lazy="item.img"/>
                  </div>
                </div>
                <div
                    v-else-if="data.type != 0 && index > 0"
                    class="home__customThreeMap_left-block"
                    @click="gotoIframe(item.url)"
                >
                  <img v-lazy="item.img"/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 自定义四图（2+2） -->
        <div
            v-if="data.moduleType == 7 && data.homepageData.length > 0"
            :mg-stat-lob="`smod=${data.moduleId}&stype=2`"
            :mg-stat-mod="data.moduleId"
            :style="{
            background: 'url(' + data.bottomImg + ')',
            backgroundSize: 'contain'
          }"
            class="home__customFourMap"
            mg-stat-show="flag=200"
        >
          <module-title :data="data"></module-title>
          <div class="home__customFourMap-main">
            <div
                v-for="(item, index) in data.homepageData"
                :key="index"
                :mg-stat-custom="'label=goods&cont='+getRequest(item.url)+'&direct=cntp&addr=' +encodeURIComponent(item.url)"
                :mg-stat-lob="`goodsdc=${goodsdc}`"
                class="home__customFourMap-item"
                mg-stat-click
                @click="gotoIframe(item.url)">
              <div v-if="data.type == 0" class="home__customFourMap-block">
                <div class="home__customFourMap-img">
                  <img v-lazy="item.img"/>
                </div>
                <div class="home__customFourMap-title">
                  <div class="customTitle">
                    <p class="add_dot">{{ item.mainTitle }}</p>
                    <p class="add_dot">{{ item.viceTitle }}</p>
                  </div>
                </div>
              </div>
              <div
                  v-else
                  class="home__customFourMap-block"
                  @click="gotoIframe(item.url)"
              >
                <img v-lazy="item.img"/>
              </div>
            </div>
          </div>
        </div>
        <!-- 自定义四图(横排) -->
        <div
            v-if="data.moduleType == 8 && data.homepageData.length > 0"
            :mg-stat-lob="`smod=${data.moduleId}&stype=2`"
            :mg-stat-mod="data.moduleId"
            :style="{
            background: 'url(' + data.bottommg + ')',
            backgroundSize: 'contain'
          }"
            class="home__customFourHorizontalMap"
            mg-stat-show="flag=200"
        >
          <module-title :data="data"></module-title>
          <div class="home__customFourHorizontalMap-main">
            <div
                v-for="(item, index) in data.homepageData"
                :key="index"
                :mg-stat-custom="'label=goods&cont='+getRequest(item.url)+'&direct=cntp&addr=' +encodeURIComponent(item.url)"
                :mg-stat-lob="`goodsdc=${goodsdc}`"
                class="home__customFourHorizontalMap-item"
                mg-stat-click
                @click="gotoIframe(item.url)">
              <img v-lazy="item.img"/>
            </div>
          </div>
        </div>
        <!-- 自定义四图(1+3) -->
        <div
            v-if="data.moduleType == 9 && data.homepageData.length > 0"
            :mg-stat-lob="`smod=${data.moduleId}&stype=1`"
            :mg-stat-mod="data.moduleId"
            :style="{
            background: 'url(' + data.bottomImg + ')',
            backgroundSize: 'contain'
          }"
            class="home__customFourTopMap"
            mg-stat-show="flag=200"
        >
          <module-title :data="data"></module-title>
          <div class="home__customFourTopMap-main">
            <div
                :mg-stat-custom="'label=goods&cont='+getRequest(data.homepageData[0].url)+'&direct=cntp&addr=' +encodeURIComponent(data.homepageData[0].url)"
                :mg-stat-lob="`goodsdc=${goodsdc}`"
                class="home__customFourTopMap-top"
                mg-stat-click
                @click="gotoIframe(data.homepageData[0].url)"
            >
              <img v-lazy="data.homepageData[0].img"/>
            </div>
            <div class="home__customFourTopMap-bottom">
              <div
                  v-for="(item, index) in data.homepageData"
                  :key="index"
                  :class="[
                  'home__customFourTopMap-item',
                  index == 0 ? 'blank' : ''
                ]"
                  :mg-stat-custom="'label=goods&cont='+getRequest(item.url)+'&direct=cntp&addr=' +encodeURIComponent(item.url)"
                  :mg-stat-lob="`goodsdc=${goodsdc}`"
                  mg-stat-click
                  @click="gotoIframe(item.url)"
              >
                <img v-if="index != 0" v-lazy="item.img"/>
              </div>
            </div>
          </div>
        </div>

        <!-- 热推单品 -->
        <div
            v-if="data.moduleType == 11"
            v-infinite-scroll="loadMoreHomeHot"
            :infinite-scroll-distance="200"
            :mg-stat-mod="data.moduleId"
            :style="{
            background: 'url(' + data.bottomImg + ')',
            backgroundSize: 'contain'
          }"
            class="home__hot"
        >
          <module-title :data="data"></module-title>
          <div class="home__hot-main">
            <div
                v-for="(item, index) in hotGoods"
                :key="index"
                :class="[
                'home__hot-goods',
                (index + 1) % 3 === 0 ? 'nomargin' : ''
              ]"
                :mg-stat-custom="'label=goods&cont=' +item.goodsId +'&direct=cntp&addr=goods/detail'"
                :mg-stat-lob="`goodsdc=${goodsdc}`"
                mg-stat-click
                @click="gotoGoodsDetail(item)"
            >
              <div
                  :mg-stat-lob="'smod=1&stype=1&goods_id=' + item.goodsId"
                  class="home__hot-img"
                  mg-stat-show="flag=200"
              >
                <img v-lazy="item.originalImg"/>
              </div>
              <div class="home__hot-goodsDesc">
                <p class="add_dot">{{ item.catName }}</p>
                <p class="add_dot2">{{ item.goodsName }}</p>
                <p>
                  <span>{{ handleJavaGoodsPrice(item) }}</span>
                  <span
                      v-for="(tag, index) in item.tags"
                      :key="index"
                      class="goods_tags"
                  >{{ tag }}</span
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- 热推专题 -->
        <div
            v-if="data.moduleType == 12"
            v-infinite-scroll="loadMoreTopic"
            :infinite-scroll-disabled="topicLoading"
            :infinite-scroll-distance="30"
            :mg-stat-mod="data.moduleId"
            :style="{
            background: 'url(' + data.bottomImg + ')',
            backgroundSize: 'contain'
          }"
            class="home__topic-main"
        >
          <div
              v-for="(item, index) in topicList"
              :key="index"
              class="home__topic"
          >
            <div class="home__topic-background">
              <img
                  v-lazy="item.positionCode"
                  :mg-stat-custom="'label=special&cont=' +item.positionId +'&direct=cntp&addr=goods/detail'"
                  mg-stat-click
                  @click="gotoTopicDetail(item.positionId)"
              />
            </div>
            <div :id="getId(index)" class="swiper-container">
              <div class="swiper-wrapper">
                <dl
                    v-for="(good, index2) in item.goodsList"
                    :key="index2"
                    :mg-stat-custom="'label=goods&cont=' +good.goodsId +'&direct=cntp&addr=goods/detail'"
                    :mg-stat-lob="`sp_id=${item.positionId}&goodsdc=${goodsdc}`"
                    class="swiper-slide"
                    mg-stat-click
                    @click="gotoGoodsDetail(good)"
                >
                  <dt>
                    <img
                        v-lazy="good.originalImg"
                        :mg-stat-lob="'smod=1&stype=1&goods_id=' + good.goodsId"
                        alt=""
                        mg-stat-show="flag=200"
                    />
                  </dt>
                  <dd>
                    <div class="home__topic-desc">
                      <p class="add_dot">{{ good.catName }}</p>
                      <p class="add_dot2">{{ good.goodsName }}</p>
                      <p>
                        <span>{{ handleJavaGoodsPrice(good) }}</span>
                        <span
                            v-for="(item, index) in good.tags"
                            :key="index"
                            class="goods_tags"
                        >{{ item }}
                        </span>
                      </p>
                    </div>
                  </dd>
                </dl>
                <dl
                    class="swiper-slide home__topic-more"
                    @click="gotoTopicDetail(item.positionId)"
                >
                  <img :src="homeMorePng" alt=""/>
                </dl>
              </div>
            </div>
          </div>
          <page-loading v-if="topicLoading"></page-loading>
        </div>

        <!-- 猜你喜欢 -->
        <div
            v-if="data.moduleType == 13"
            v-infinite-scroll="loadMore"
            :infinite-scroll-disabled="loading"
            :infinite-scroll-distance="100"
            :mg-stat-mod="data.moduleId"
            :style="{
            background: 'url(' + data.bottomImg + ')',
            backgroundSize: 'contain'
          }"
            class="home__mayLike"
        >
          <module-title :data="data"></module-title>
          <div class="home__mayLike-main">
            <div
                v-for="(item, index) in goodsList"
                :key="index"
                :class="[
                'home__mayLike-goods',
                (index + 1) % 2 === 0 ? 'nomargin' : ''
              ]"
                :mg-stat-custom="'label=goods&cont=' +item.goodsId +'&direct=cntp&addr=goods/detail'"
                :mg-stat-lob="`goodsdc=${goodsdc}`"
                mg-stat-click
                @click="gotoGoodsDetail(item)"
            >
              <div class="home__mayLike-img">
                <img
                    v-lazy="item.originalImg"
                    :mg-stat-lob="'smod=1&stype=1&goods_id=' + item.goodsId"
                    mg-stat-show="flag=200"
                />
              </div>
              <div class="home__mayLike-desc">
                <p class="add_dot">{{ item.catName }}</p>
                <p class="add_dot2">{{ item.goodsName }}</p>
                <p>
                  <span>{{ handleJavaGoodsPrice(item) }}</span>
                  <span v-if="item.memberGoodsPrice" class="member">
                    <span class="vtag">VIP</span>
                    <span class="tag">￥</span>{{ item.memberGoodsPrice }}
                  </span>
                  <span
                      v-for="(tag, index) in item.tags"
                      :key="index"
                      class="goods_tags"
                  >{{ tag }}</span
                  >
                </p>
              </div>
            </div>
          </div>
          <page-loading v-if="loading"></page-loading>
        </div>

        <!-- 自定义三图(3|9) -->
        <div
            v-if="data.moduleType == 14 && data.homepageData.length > 0"
            :mg-stat-lob="`smod=${data.moduleId}&stype=2`"
            :mg-stat-mod="data.moduleId"
            :style="{
            background: 'url(' + data.bottomImg + ')',
            backgroundSize: 'contain'
          }"
            class="home__customThreeOrNineMap"
            mg-stat-show="flag=200"
        >
          <module-title :data="data"></module-title>
          <div class="home__customThreeOrNineMap-main">
            <div
                v-for="(item, index) in data.homepageData"
                :key="index"
                :mg-stat-custom="
                'label=goods&cont='+getRequest(item.url)+'&direct=cntp&addr=' +encodeURIComponent(item.url)"
                :mg-stat-lob="`goodsdc=${goodsdc}`"
                class="home__customThreeOrNineMap-item"
                mg-stat-click
                @click="gotoIframe(item.url)"
            >
              <img v-lazy="item.img"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <nav-button></nav-button>
    <qr-code
        v-if="Env.isPc"
        :isShow="showQrCode"
        :url="nowUrl"
        @close="showQrCode = false"
    ></qr-code>
    <wake-button></wake-button>
    <fixed-header :hidden="true" :shareContent="shareContent"></fixed-header>
    <pop-ups :popUpsList="homeAdConfig.popups"></pop-ups>
    <levitate :levitate="homeAdConfig.levitate"></levitate>
  </div>
</template>
<script>
import PageLoading from 'components/common/PageLoading';
import FixedHeader from 'components/common/FixedHeader';
import NavButton from 'components/common/NavButton';
import CouponToast from 'components/common/CouponToast';
import PopUps from 'components/common/PopUps';
import Levitate from 'components/common/Levitate';
import QrCode from 'components/common/QrCode';
import WakeButton from 'components/common/WakeButton';
import ModuleTitle from 'components/home/ModuleTitle';
import homeGoodsPng from 'assets/img/home_goods.png';
import homeMorePng from 'assets/img/home_more.png';
import _ from 'lodash';
import * as homeApis from 'apis/home';
import * as goodsApis from 'apis/goods';
import Env from 'utils/env';
import { handleGoodsNum, handleGoodsPrice, handleJavaGoodsPrice } from 'utils/goods';
import { setWeixinShare } from 'utils/weixin';
import { beforeRouteChange, initCloseUpload, setFixedParams, uploadAccessData, uploadCloseData } from 'utils/uploadData';
import DataStorage from 'utils/dataStore';
import Swiper from 'Swiper';
import { guid } from 'utils/index';
import { mapMutations } from 'vuex';

export default {
  components: {
    PageLoading,
    NavButton,
    QrCode,
    WakeButton,
    FixedHeader,
    CouponToast,
    PopUps,
    Levitate,
    ModuleTitle,
  },
  data() {
    return {
      Env,
      homeGoodsPng,
      homeMorePng,
      topicList: [],
      goodsList: [],
      hotGoods: [],
      loading: false,
      disableLoad: false,
      noTopic: false,
      pageNo: 1,
      topicPageNo: 1,
      topicLoading: false,
      disableLoadHomeHot: false,
      goodsId: 0,
      isShowSkuParams: false,
      showQrCode: false,
      nowUrl: window.location.href,
      hasAnyAction: false, // 是否有操作
      hasRouteChange: false,
      shareContent: {
        title: '芒果TV官方周边 尽在芒果好物',
        shareDesc: '一份好物复刻你的美好时光 ',
        shareUrl: window.location.href,
        shareIcon: 'http://lingxi.mgtv.com/shop-static/logo.png',
      },
      homePageData: [],
      goodsdc: this.guid(),
      nowPage: DataStorage.getNowPage(),
      homeAdConfig: {},
    };
  },
  watch: {
    hasAnyAction: {
      handler(val) {
        DataStorage.setPageVisitiLog(val);
      },
      immediate: true,
    },
  },
  async created() {
    await this.getHomeModuleData();
    await this.getHomeAdConfig();
    await setFixedParams(this);
    uploadAccessData();
    setWeixinShare(this.shareContent);
  },
  activated() {
    this.goodsdc = this.guid();
    if (DataStorage.getPrePage()) {
      // 有上一级路由才上报 不然第一次进入会上报两次
      uploadAccessData();
      DataStorage.setPageVisitiLog(this.hasAnyAction);
    }
    document.getElementById('home').scrollTop = sessionStorage.homeScroll;
  },
  mounted() {
    initCloseUpload();
  },
  beforeRouteLeave(to, from, next) {
    if (!this.hasRouteChange) {
      uploadCloseData();
    }
    next();
  },
  methods: {
    ...mapMutations('homePage', ['changeHomePageData']),
    guid,
    handleGoodsNum,
    handleGoodsPrice,
    handleJavaGoodsPrice,
    async fetchGoodsHot() {
      if (this.homePageData && this.homePageData.length) {
        const data = this.homePageData.find(v => v.moduleType === 11);
        if (data) {
          const goodsIds = data.homepageData.map(v => v.goodsId);
          const goodsApiData = await goodsApis.getGoodsList({
            goodsIds,
          });
          if (Array.isArray(goodsApiData)) {
            this.hotGoods = goodsApiData.splice(0, 6);
          }
        }
      }
    },
    setScroll() {
      sessionStorage.homeScroll = document.getElementById('home').scrollTop;
    },
    gotoIframe(link) {
      if (!link) {
        return;
      }
      if (
        link.indexOf('/topic') !== -1 ||
          link.indexOf('h5.da.mgtv.com') !== -1
      ) {
        window.location.href = link;
      } else {
        const flag = link.indexOf('?') > -1 ? '&' : '?';
        this.$router.push({
          path: 'iframe',
          query: { link: encodeURIComponent(`${link}${flag}goodsdc=${this.goodsdc}&lastp=haowu_${this.nowPage}`) },
        });
      }
    },
    gotoGoodsDetail(item) {
      this.hasAnyAction = true;
      beforeRouteChange(
        { path: 'goods/detail', query: { id: item.goods_id || item.goodsId, showBack: 1, goodsdc: this.goodsdc } },
        this,
      );
    },
    addCart(id) {
      if (Env.isPc) {
        this.showQrCode = true;
        return;
      }
      this.goodsId = id;
      this.isShowSkuParams = true;
    },
    gotoTopicDetail(id) {
      this.hasAnyAction = true;
      if (Env.isPc) {
        this.showQrCode = true;
        return;
      }
      beforeRouteChange({ path: '/topic', query: { id } }, this);
    },
    showShippingLabel(val) {
      return val ? '包邮' : '不包邮';
    },
    /* 页面初始化会自运行一次 组件的功能  */
    loadMore: _.throttle(function () {
      if (this.disableLoad || this.topicLoading) {
        return;
      }
      this.fetchGoodsList();
    }, 500),
    loadMoreTopic: _.throttle(function () {
      if (this.noTopic || this.topicLoading) {
        // 禁止第一次自运行
        return;
      }
      this.fetchTopicList();
    }, 1000),
    loadMoreHomeHot: _.throttle(function () {
      // 运行一次
      if (this.disableLoadHomeHot) {
        return;
      }
      this.fetchGoodsHot();
      this.disableLoadHomeHot = true;
    }, 500),
    async fetchTopicList() {
      this.topicLoading = true;
      try {
        const data = await goodsApis.getTopicList({ p: this.topicPageNo });
        if (data && Array.isArray(data.records)) {
          this.topicList.push(...data.records);
          setTimeout(() => {
            this.initTopicSwiper();
          }, 100);
          if (!data.records.length || data.records.length < 10) {
            // 没数据就不再请求
            this.noTopic = true;
          }
        } else {
          this.noTopic = true;
        }
      } catch (error) {
        this.noTopic = true;
      }
      this.topicPageNo += 1;
      this.topicLoading = false;
    },
    async fetchGoodsList() {
      this.loading = true;
      this.disableLoad = true; // 防止重复调用
      const { pageNo } = this;
      try {
        const data = await goodsApis.getGoodsList({
          p: pageNo,
          sort: 'on_time',
        });
        this.disableLoad = false;
        if (Array.isArray(data)) {
          this.goodsList.push(...data);
          if (!data.length || data.length < 10) {
            // 没数据就不再请求
            this.disableLoad = true;
          }
        }
      } catch (error) {
        this.$toast(`${error.message}`);
      }
      this.pageNo += 1;
      this.loading = false;
    },
    getId(index) {
      return `swiper_topic${index}`;
    },
    initBannerSwiper(bannerNum) {
      const that = this;
      if (!bannerNum) {
        return;
      }
      this.bannerSwiper = new Swiper('#swiper_home', {
        watchSlidesProgress: false,
        slidesPerView: 'auto',
        centeredSlides: true,
        allowTouchMove: bannerNum > 1,
        observer: true,
        effect: 'slide',
        autoplay:
            bannerNum > 1
              ? {
                disableOnInteraction: false,
                delay: 4000,
              }
              : false,
        pagination:
            bannerNum > 1
              ? {
                el: '.swiper-pagination',
              }
              : '',
        loop: true,
        loopedSlides: bannerNum,
        on: {
          click(e) {
            that.gotoIframe(e.target.getAttribute('data-link'));
          },
        },
      });
    },
    initTopicSwiper() {
      this.topicList.forEach((item, index) => {
        setTimeout(
          () =>
            new Swiper(`#swiper_topic${index}`, {
              slidesPerView: 'auto',
            }),
          100 * (index + 1),
        );
      });
    },
    async getHomeModuleData() {
      try {
        const data = await homeApis.getHomeModuleData({ isCache: 0 });
        if (Array.isArray(data)) {
          this.changeHomePageData(data);
          this.homePageData = data;
          this.homePageData.forEach((element) => {
            if (element.moduleType === 0 && element.homepageData.length) {
              setTimeout(() => {
                this.initBannerSwiper(element.homepageData.length);
              }, 100);
            }
          });
        }
      } catch (error) {
        this.$toast(`${error.message}`);
      }
    },
    //  获取广告与用户购物车数据
    async getHomeAdConfig() {
      try {
        const data = await homeApis.getHomeAdConfig();
        if (data) {
          this.homeAdConfig = data;
        }
      } catch (error) {
        this.$toast(`${error.message}`);
      }
    },
    getRequest(url) {
      const theRequest = {};
      if (url && url.indexOf('?') !== -1) {
        const str = url.substr(url.indexOf('?') + 1);
        const strs = str.split('&');
        for (let i = 0; i < strs.length; i += 1) {
          theRequest[strs[i].split('=')[0]] = decodeURIComponent(strs[i].split('=')[1]);
        }
      }
      return theRequest.id || '';
    },
  },
};
</script>

